// extracted by mini-css-extract-plugin
module.exports =  {"name":"xmtxgzByyoaBfU8S8xB1","prefix":"gHiUYXWauiMjCla0IHb9","prefixDisabled":"JQpD7O931FBYjHyHcIZR"};